import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import { Address } from './styles';
import iconSrc from '../../utils/iconSrc';

const AddressLink = ({ placeID, address }) => {
  let gMapsLink;
  const baseLinkURL = 'https://google.com/maps/place/';

  if (placeID) {
    gMapsLink = `${baseLinkURL}?q=place_id:${placeID}`;
  } else {
    gMapsLink = `${baseLinkURL}${encodeURI(address)}`;
  }

  return (
    <Address>
      <SVG src={iconSrc('map-marker')} cacheRequests />
      <a href={gMapsLink} target="_blank" rel="noopener noreferrer">
        {address}
      </a>
    </Address>
  );
};

AddressLink.propTypes = {
  placeID: PropTypes.string,
  address: PropTypes.string.isRequired,
};

export default AddressLink;
